<template>
  <div
    class="modal has-overflow"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>

    <div class="modal-content">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Add New Cut Sheet</p>
          <button
            class="delete"
            aria-label="close"
            @click="close()">
          </button>
        </header>
        <v-form :valid.sync="valid" class="modal-card-body">
          <div class="field">
            <label class="label">Project</label>
            <search-autocomplete
              required
              v-model="cutSheetCopy.project_id"/>
            <span class="help">
              Please choose a project for which this cut sheet will be created
            </span>
          </div>
          <div class="field">
            <label class="label">Cut Sheet No.</label>
            <v-text-field
              required
              placeholder="Enter Cut Sheet No."
              v-model="cutSheetCopy.cutsheet_no">
            </v-text-field>
          </div>
          <div class="field">
            <label class="label">Item</label>
            <v-text-field
              required
              placeholder="Enter Cut Sheet Item"
              v-model="cutSheetCopy.item">
            </v-text-field>
          </div>
          <div class="field">
            <label class="label">Material</label>
            <product-selector
              v-model="cutSheetCopy.input_product_master_id">
            </product-selector>
          </div>
        </v-form>

        <footer class="modal-card-foot">
          <button 
            class="button is-primary" 
            @click="addNewCutSheet()">
            Save
          </button>
          <button 
            class="button is-primary" 
            @click="addNewCutSheet(true)">
            Save and Edit
          </button>
          <button class="button" @click="close()">
            Cancel
          </button>
        </footer>

      </div>
    </div>
  </div>
</template>

<script>
import VTextField from '@/components/base/VTextField'
import VForm from '@/components/base/VForm'
import SearchAutocomplete from '@/components/projects/SearchAutocomplete'
import ProductSelector from '@/components/inventory/ProductSelector'

import { mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    },
    materials: {
      type: Array
    },
    cutSheet: {
      type: Object
    }
  },
  components: { 
    VTextField, VForm, SearchAutocomplete, ProductSelector
  },
  data() {
    return {
      valid: false,
      cutSheetCopy: {
        project_id: null,
        cutsheet_no: null,
        item: null,
        material_id: null,
        parts: []
      }
    }
  },
  watch: {
    value(v) {
      if (v) {
        this.cutSheetCopy = this.cutSheet;
      }
    }
  },
  methods: {
    ...mapActions("cutSheets", ["addCutSheet"]),
    close() {
      this.$emit('input', false);
    },
    addNewCutSheet(edit=false) {
      let cutSheetToPost = Object.assign({}, this.cutSheetCopy);
      cutSheetToPost.parts = [];

      this.addCutSheet(cutSheetToPost).then(
        resp => {
          this.close();
          if (edit) {
            this.$emit("go", resp.data);
          }
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/modal.scss';
</style>